import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import uk from "vuetify/es5/locale/uk";
import "@/scss/custom-styles.scss";

Vue.use(Vuetify, {
  theme: {
    primary: "#ee44aa",
    secondary: "#424242",
    accent: "#82B1FF",
    error: "#FF5252",
    info: "#2196F3",
    success: "#4CAF50",
    warning: "#FFC107",
    purple: "#800057"
  },
  customProperties: true,
  iconfont: "md",
  lang: {
    locales: { uk },
    current: "uk"
  }
});
